module.exports = __webpack_public_path__ + "static/media/wavey.48b1cb0d.png";